import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import {
  disconnectShopifyStore,
  resyncShopifyStore,
  clearShopifyStoreInfo,
} from 'redux/integrations/actions';

import ShopifyConnectionProgressBar
  from 'components/dashboard/integrations/shopify/ShopifyConnectionProgressBar';
import SynchronizeShopifyCheckbox
  from 'components/dashboard/integrations/shopify/SynchronizeShopifyCheckbox';
import DisconnectShopifyStoreButton
  from 'components/dashboard/integrations/shopify/DisconnectShopifyStoreButton';
import ResyncShopifyStoreButton
  from 'components/dashboard/integrations/shopify/ResyncShopifyStoreButton';

import './ShopifyStoreInfo.css';

const ShopifyStoreInfo = props => {
  const {
    disconnectShopifyStore,
    resyncShopifyStore,
    shopifyStoreInfo,
    clearShopifyStoreInfo,
  } = props;

  return (
    <div className="shopify-store-info__component">
      <div className="header-text">
        Your Shopify Store Info
      </div>

      <div className="store-info-block">
        <div className="parameter">
          <div className="parameter-name">Store:</div>
          <div className="value">{shopifyStoreInfo.shop_name}</div>
        </div>
        <div className="parameter">
          <div className="parameter-name">Website:</div>
          <div className="value">{shopifyStoreInfo.shop_domain}</div>
        </div>
        <div className="parameter">
          <div className="parameter-name">Myshopify Website:</div>
          <div className="value">{shopifyStoreInfo.shop_myshopify_domain}</div>
        </div>
      </div>

      <div className="progress-block">
        <ShopifyConnectionProgressBar
          shopifyStoreInfo={shopifyStoreInfo}
        />
      </div>

      <div className="integration-settings">
        <div className="section-title">Integration Settings</div>
        <SynchronizeShopifyCheckbox
          isSynchronized={shopifyStoreInfo.sync_products}
        />
        <div className="buttons-block">
          <ResyncShopifyStoreButton
            disabled={shopifyStoreInfo.sync_products_in_progress}
            resyncShopifyStore={resyncShopifyStore}
            clearShopifyStoreInfo={clearShopifyStoreInfo}
          />
          <DisconnectShopifyStoreButton
            disabled={shopifyStoreInfo.sync_products_in_progress}
            disconnectShopifyStore={disconnectShopifyStore}
          />
        </div>
      </div>

    </div>
  );
};

ShopifyStoreInfo.propTypes = {
  disconnectShopifyStore: PropTypes.func.isRequired,
  resyncShopifyStore: PropTypes.func.isRequired,
  clearShopifyStoreInfo: PropTypes.func.isRequired,
  shopifyStoreInfo: PropTypes.object,
};

ShopifyStoreInfo.defaultProps = {
  shopifyStoreInfo: null,
};

const mapStateToProps = state => (
  {
    shopifyStoreInfo: state.integrationsReducer.shopifyStoreInfo,
  }
);

export default connect(
  mapStateToProps,
  {
    disconnectShopifyStore,
    resyncShopifyStore,
    clearShopifyStoreInfo,
  },
)(ShopifyStoreInfo);
